import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { BaseResponseModel, SelectListItem } from "app/core/models";
import { SendNotificationModel } from "../model";

export const SEND_NOTIFICATION_SERVICE = new InjectionToken('repair work service...')

export interface SendNotificationInterface {

  getsendNotificationList(sendNotificationData: SendNotificationModel): Observable<BaseResponseModel<SendNotificationModel>>;

}
